import { Upload, message, Button, Image } from "antd";
import { PlusOutlined } from "@ant-design/icons";

export default function BigProjectImageUploader({ imageFile, setImageFile }) {
  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("Faqat rasm fayllari qabul qilinadi!");
      return false;
    }
    return true;
  };

  const handleChange = (info) => {
    if (info.file.status === 'done') {
      setImageFile(info.file.originFileObj);
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <Upload
        name="image"
        listType="picture-card"
        showUploadList={false}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        accept="image/*"
        customRequest={({ file, onSuccess }) => {
          setTimeout(() => onSuccess(), 0);
        }}
      >
        {imageFile ? (
          <img
            src={typeof imageFile === 'string' ? imageFile : URL.createObjectURL(imageFile)}
            alt="uploaded"
            style={{ width: "100%", maxHeight: "100%" }}
          />
        ) : (
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Rasm yuklash</div>
          </div>
        )}
      </Upload>

      {imageFile && (
        <Button
          danger
          type="text"
          onClick={() => setImageFile(null)}
          style={{ marginTop: 8 }}
        >
          Rasmni o'chirish
        </Button>
      )}
    </div>
  );
}